import React, { useState } from "react";
import styled from "styled-components";
import FormGeneralData from "./FormGeneralData";
import { useImmer } from "use-immer";
import FormCheckout from "./FormCheckout";
import _ from "lodash";
import NotificationSuccess from "./NotificationSuccess";
import { useHistory } from "react-router-dom";
import UserAPI from "../../apis/UserAPI";

const FormMain = ({ price = undefined, discountPercentage = 0, courseId = undefined, onClose = () => {} }) => {
  let history = useHistory();

  const [formState, setFormState] = useImmer({
    generalData: undefined,
  });
  const [state, setState] = useImmer({});

  const [stage, setStage] = useState("GENERAL_DATA");

  const [modal, setModal] = useState(undefined);

  return (
    <>
      <Container>
        <LogoImg src={require("../../assets/images/solicitaCupon.jpeg")} />
        <Description>Paga con tarjeta de crédito o débito</Description>
        <Payments>
          <PaymentImg src="visa.png" />
          <PaymentImg src="mastercard.png" />
          <PaymentImg src="american-express.png" />
          <PaymentImg src="diners-club.png" />
        </Payments>
        <FormContainer>
          {stage === "GENERAL_DATA" && (
            <FormGeneralData
              courseId={courseId}
              values={formState.generalData?.values}
              errors={formState.generalData?.errors}
              touched={formState.generalData?.touched}
              onChange={(data) => {
                setFormState((draft) => {
                  draft.generalData = data;
                });
              }}
              onSubmit={(data, onResolve) => {
                setState((draft) => ({
                  ...draft,
                  correo: data.correo,
                  telefonoCelular: _.trim(data.telefonoCelular).replace(
                    / /g,
                    ""
                  ),
                  cupon: _.upperCase(data.cupon).replace(/ /g, ""),
                }));
                onResolve();
                setStage("CHECKOUT");
              }}
            />
          )}
          {stage === "CHECKOUT" && (
            <FormCheckout
              courseId={courseId}
              email={state.correo}
              phone={state.telefonoCelular}
              price={
                state.cupon === "SOYREBELDE"
                  ? price - price * (discountPercentage / 100)
                  : price
              }
              onSubmitSuccess={(data) => {
                if (data.isNewUser)
                  UserAPI.login(data.email, data.password).then(() => {
                    setModal({
                      success: true,
                      account: { email: data.email, password: data.password },
                    });
                  });
                else
                  setModal({
                    success: true,
                    account: { email: data.email },
                  });
              }}
            />
          )}
        </FormContainer>
      </Container>
      <NotificationSuccess
        isOpen={modal?.success === true}
        account={modal?.account}
        onClose={() => {
          setModal(undefined);
          onClose();
          history.push(`/${courseId}`);
        }}
      />
    </>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoImg = styled.img`
  width: 100%;
  margin-bottom: 35px;
  border-radius: 15px;
`;

const Description = styled.div`
  margin-bottom: 15px;
`;

const Payments = styled.div`
  margin-bottom: 35px;
`;

const PaymentImg = styled.img`
  height: 23px;
  margin: 5px;
`;

const FormContainer = styled.div`
  width: 100%;
`;

export default FormMain;
